import f from './f.png';
import fq from './fq.png';
import lq from './lq.png';
import n from './n.png';
import wnc from './wnc.png';
import wng from './wng.png';
import wxc from './wxc.png';
import wxg from './wxg.png';

export const MOON_ICON_PATH_MAP = {
  f,
  fq,
  lq,
  n,
  wnc,
  wng,
  wxc,
  wxg,
};
